import { create } from 'zustand';

const usePType = create((set) => ({
    projectTypes: [],
    setProjectTypes: (projectTypes) => set({ projectTypes }),
}));

export default usePType;